import React from 'react';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconSrc: string;
  iconAlt?: string;
  iconClassName?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  iconSrc,
  iconAlt = '',
  iconClassName,
  type = 'button',
  ...props
}) => {
  return (
    <button type={type} {...props}>
      <img src={iconSrc} alt={iconAlt} className={iconClassName} aria-hidden={iconAlt ? undefined : true} />
    </button>
  );
};

export default IconButton;
